<template>
  <div class="curr-month-overview">
    <div class="flex-align-center">
      <img
        src="@/assets/imgs/school/monthRecord/characterLine.png"
        alt=""
        style="width: 20px; height: 20px; margin-right: 5px"
      />
      <div class="record-title">重点学生管理</div>
    </div>
    <div class="title-1" style="margin: 20px 0 15px">{{ formatMonth }}月全校提醒总数及构成情况</div>
    <div class="overview-list flex-between">
      <div class="overview-list-item">
        <div class="card-title">
          <div>提醒总数</div>
          <img
            src="@/assets/imgs/school/monthRecord/smallBellCircle.png"
            alt=""
            class="item-icon"
          />
        </div>
        <div style="transform: translateY(-15px)">
          <CountAnimation :end-val="cardInfo.remindStudentCount" class="count-bold" />
        </div>
      </div>
      <div class="overview-list-item">
        <div class="card-title">
          <div>两次提醒</div>
          <img
            src="@/assets/imgs/school/monthRecord/moreTwiceCircle.png"
            alt=""
            class="item-icon"
          />
        </div>
        <div style="transform: translateY(-15px)">
          <CountAnimation :end-val="cardInfo.twoRemindStudentCount" class="count-bold" />
          人
        </div>
        <div>
          占总提醒
          <span style="color: #ff4646">{{ cardInfo.twoRemindStudentRate }}%</span>
        </div>
      </div>
      <div class="overview-list-item">
        <div class="card-title">
          <div>三次及以上提醒</div>
          <img src="@/assets/imgs/school/monthRecord/moreThreeTimes.png" alt="" class="item-icon" />
        </div>
        <div style="transform: translateY(-15px)">
          <CountAnimation :end-val="cardInfo.threeRemindStudentCount" class="count-bold" />
          名
        </div>
        <div>
          占总提醒
          <span style="color: #ff4646">{{ cardInfo.threeRemindStudentRate }}%</span>
        </div>
      </div>
      <div class="overview-list-item">
        <div class="card-title">
          <div>关爱名单提醒</div>
          <img src="@/assets/imgs/school/monthRecord/loveRedCircle.png" alt="" class="item-icon" />
        </div>
        <div style="transform: translateY(-15px)">
          <CountAnimation :end-val="cardInfo.careStudentRemindCount" class="count-bold" />
          次
        </div>
        <div>
          占总提醒
          <span style="color: #ff4646">{{ cardInfo.careStudentRemindRate }}%</span>
        </div>
      </div>
    </div>
    <div class="flex-between" style="margin-top: 15px">
      <div class="title-1">重点学生班主任关怀情况</div>
      <div style="color: #2a82e4; cursor: pointer" @click="viewModal">
        查看详情
        <a-icon type="right" />
      </div>
    </div>
    <TableList
      style="width: 100%"
      :columns="columns"
      :tableData="dataSource"
      :loading="loading"
      :scroll="{}"
    >
      <!--<template #action="{ record }">-->
      <!--  <span style="color: #1783e8; cursor: pointer" @click="viewReport(record)">查看报告</span>-->
      <!--</template>-->
    </TableList>
    <div class="tip">
      <span>
        <img
          src="@/assets/imgs/school/monthRecord/analyse.png"
          alt=""
          style="width: 14px; height: 14px; margin-right: 5px"
        />
        关爱名单学生需建立个性化关怀档案,记录关怀过程、学生反馈及情绪变化趋势。对于同时属于多次提醒名单的学生,需启动二级干预机制,每周至少1次专项关怀。
      </span>
    </div>
    <!--详情模态框-->
    <DetailModal
      ref="detailModalRef"
      title="重点学生班主任关怀情况"
      :columns="columns"
      :url="url"
    />
  </div>
</template>
<script>
import CountAnimation from '@/components/CountAnimation'
import TableList from '@comp/chart/TableList.vue'
import DetailModal from './DetailModal.vue'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'

export default {
  name: 'CurrMonthOverview',
  mixins: [JeecgListMixin],
  components: {
    CountAnimation,
    TableList,
    DetailModal,
  },
  props: {
    dateRange: {
      type: Object,
      default: () => ({}),
    },
    currMonthInfo: {
      type: Object,
      default: () => ({}),
    },
    cardInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      // 重点学生班主任关怀情况分页查询
      url: {
        list: '/emotionalReport/queryTeachCareStudentList',
        exportXlsUrl: '/emotionalReport/queryTeachCareStudentExport',
      },
      disableMixinCreated: true,
      columns: [
        {
          title: '班级',
          dataIndex: 'className',
          align: 'center',
        },
        {
          title: '姓名',
          dataIndex: 'studentName',
          align: 'center',
        },
        {
          title: '提醒次数',
          dataIndex: 'remindCount',
          align: 'center',
        },
        {
          title: '已关怀次数',
          dataIndex: 'dealCount',
          align: 'center',
        },
        {
          title: '是否多次提醒',
          dataIndex: 'manyRemindFlag',
          align: 'center',
        },
        {
          title: '关怀建议',
          dataIndex: 'suggestion',
          align: 'center',
          customRender: (_, record) => {
            return <div style="color:#236CFE">{record.suggestion}</div>
          },
        },
      ],
    }
  },
  watch: {
    dateRange(dateObj) {
      this.queryParam = {
        startTime: dateObj.beginDate,
        endTime: dateObj.endDate,
      }
      this.loadData(1)
    },
  },
  computed: {
    formatMonth() {
      return parseInt(this.currMonthInfo.month, 10)
    },
  },
  methods: {
    viewModal() {
      this.$refs.detailModalRef.showModal(this.queryParam)
    },
  },
}
</script>
<style scoped lang="less">
.curr-month-overview {
  padding: 20px;
  background-color: #fff;
  border-radius: 10px;
  .overview-list {
    .overview-list-item {
      box-sizing: border-box;
      width: 24%;
      height: 150px;
      padding: 16px;
      border: 1px solid #f3f4f6;
      border-radius: 10px;
      .card-title {
        display: flex;
        justify-content: space-between;
      }
      .count-bold {
        font-size: 24px;
        font-weight: bold;
      }
      .item-icon {
        width: 56px;
        height: 56px;
        border-radius: 9999px;
      }
    }
  }
  .tip {
    padding: 15px;
    border-radius: 10px;
    line-height: 1.8;
    background-color: #eff6ff;
  }
}
</style>
